import { Component, DoCheck, ViewEncapsulation, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { map } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { race } from 'rxjs/observable/race';
import { State } from '../../store/reducers';

/** Top part of the main dashboard */
@Component({
  selector: 'app-top-panel',
  templateUrl: './top-panel.component.html',
  styleUrls: ['./top-panel.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TopPanelComponent implements OnInit {
  bookings$;
  bookingsBgColor = { domain: ['#F47B00'] };

  constructor(private store: Store<State>) {}
  ngOnInit() {
    this.bookings$ = this.store
      .select(state => state.admin.bookingsCount)
      .pipe(map(num => [{ name: 'Total Registrations', value: num }]));
  }

  /** Formatter for icons on the dashboard */
  infoLabelFormat(c): string {
    switch (c.data.name) {
      case 'All Employees':
        return `<i class="fa fa-users mr-2"></i>${c.label}`;
      case 'Staff Employees':
        return `<i class="fa fa-user mr-2"></i>${c.label}`;
      case 'Birthdays This Month':
        return `<i class="fa fa-birthday-cake mr-2"></i>${c.label}`;
      default:
        return c.label;
    }
  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/admin/top-panel/top-panel.component.ts